import { ensureUTC } from "../../utils/Utils";

export const REMOTE_ASSISTANCE_STATUS = Object.freeze({
    UPCOMING: "upcoming",
    JOIN_ENABLED: "joinEnabled",
    SESSION_STARTED: "sessionStarted",
    IN_REVIEW: "inReview",
    COMPLETED: "completed",
    EXPIRED: "expired"
});

export const REMOTE_ASSISTANCE_STATUS_DETAILS = Object.freeze({
    [REMOTE_ASSISTANCE_STATUS.UPCOMING]: {
        label: "Upcoming",
        message: "Please join the meeting at the scheduled time. Need to cancel or reschedule? ✉️ support@atlasathlete.ai"
    },
    [REMOTE_ASSISTANCE_STATUS.JOIN_ENABLED]: {
        label: "Join enabled",
        message: "Please join the meeting. Need to cancel or reschedule? ✉️ support@atlasathlete.ai"
    },
    [REMOTE_ASSISTANCE_STATUS.SESSION_STARTED]: {
        label: "Session started",
        message: "Session is in progress. Please join the session. Need to cancel or reschedule? ✉️ support@atlasathlete.ai"
    },
    [REMOTE_ASSISTANCE_STATUS.IN_REVIEW]: {
        label: "In review",
        message: "Your assessment report is currently under review as part of our quality control process. It will be available within the next 24 hours."
    },
    [REMOTE_ASSISTANCE_STATUS.COMPLETED]: {
        label: "Completed",
        message: ""
    },
    [REMOTE_ASSISTANCE_STATUS.EXPIRED]: {
        label: "Expired",
        message: "Remote assistant appointment has expired. Please contact us if you need further assistance. ✉️ support@atlasathlete.ai"
    }
});

const JOIN_WINDOW_MS = 60 * 60 * 1000;

const parseUtcDate = (value) => {
    if (!value) return null;

    const date = new Date(ensureUTC(String(value)));
    return Number.isNaN(date.getTime()) ? null : date;
};

export const getRemoteAssistanceStatus = (remoteAssistance, now = new Date()) => {
    const reportUrl = remoteAssistance?.ReportUrl || "";

    if (!String(reportUrl).trim()) {
        const isBiometricCompleted = remoteAssistance?.IsBiometricCompleted
            ?? remoteAssistance?.BiometricCompleted
            ?? false;

        if (isBiometricCompleted) return REMOTE_ASSISTANCE_STATUS.IN_REVIEW;

        const meetingStart = parseUtcDate(remoteAssistance?.MeetingStartDate ?? remoteAssistance?.MeetingStart);
        const meetingEnd = parseUtcDate(remoteAssistance?.MeetingEndDate ?? remoteAssistance?.MeetingEnd);

        if (meetingStart && meetingEnd) {
            const currentTime = now.getTime();
            const startTime = meetingStart.getTime();
            const endTime = meetingEnd.getTime();

            if (currentTime < startTime - JOIN_WINDOW_MS) return REMOTE_ASSISTANCE_STATUS.UPCOMING;
            if (currentTime >= startTime && currentTime <= endTime + JOIN_WINDOW_MS) {
                return REMOTE_ASSISTANCE_STATUS.SESSION_STARTED;
            }
            if (currentTime >= startTime - JOIN_WINDOW_MS && currentTime < startTime) {
                return REMOTE_ASSISTANCE_STATUS.JOIN_ENABLED;
            }
            if (currentTime > endTime + JOIN_WINDOW_MS) return REMOTE_ASSISTANCE_STATUS.EXPIRED;
        }
    }

    return REMOTE_ASSISTANCE_STATUS.COMPLETED;
};

export const canJoinRemoteAssistance = (status) => (
    status === REMOTE_ASSISTANCE_STATUS.JOIN_ENABLED
    || status === REMOTE_ASSISTANCE_STATUS.SESSION_STARTED
);
